import axios from 'axios';
const setApiUrl = document.getElementById('app').getAttribute('data-ip');

class AuthService {
    login(user) {
        return axios
            .post(setApiUrl + '/api/auth/user-login', {
                username: user.username,
                password: user.password,
                encryptedHotspotId:user.encryptedHotspotId
            })
            .then(result => {
                let response = result.data;
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');

    }
}

export default new AuthService();